import { atom, selector, selectorFamily } from 'recoil'

import type {
  PaginationState,
  SearchResult,
  SelectionState,
} from 'Pages/RecipientsList/model'

export const resultsState = atom<SearchResult[]>({
  key: 'recipientsList_resultsState',
  default: [],
})

export const paginationState = atom<PaginationState>({
  key: 'recipientsList_paginationState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0,
    orderBy: 'Id',
    orderDescending: true,
    loading: false,
    forcedRecipient: false,
  },
})

export const emptyStateState = atom<boolean>({
  key: 'recipientsList_emptyStateState',
  default: false,
})

export const selectionState = atom<SelectionState>({
  key: 'recipientsList_selectionState',
  default: {
    mode: 'selection',
    checked: [],
    unchecked: [],
  },
})

export const isSelectAllCheckedState = selector<boolean>({
  key: 'recipientsList_isSelectAllCheckedState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const results = get(resultsState)

    return (
      mode === 'all' ||
      (mode === 'selection' && results.every((r) => checked.includes(r.Id)))
    )
  },
})

export const isSelectAllIndeterminateState = selector<boolean>({
  key: 'recipientsList_isSelectAllIndeterminateState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const results = get(resultsState)

    const inPageChecked = checked.filter((c) => results.some((r) => r.Id === c))

    return (
      mode === 'selection' &&
      inPageChecked.length > 0 &&
      inPageChecked.length < results.length
    )
  },
})

export const isSelectRecipientDisabled = selector<boolean>({
  key: 'recipientsList_isSelectRecipientDisabled',
  get: ({ get }) => {
    const { mode } = get(selectionState)

    return mode === 'all'
  },
})

export const isRecipientSelected = selectorFamily<boolean, number>({
  key: 'recipientsList_isRecipientSelected',
  get:
    (idRecipient: number) =>
    ({ get }) => {
      const { mode, checked } = get(selectionState)

      return mode === 'all' || checked.includes(idRecipient)
    },
})

export const selectionCountState = selector<number>({
  key: 'recipientsList_selectionCountState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const { totalItems } = get(paginationState)

    return mode === 'selection' ? checked.length : totalItems
  },
})

export const exportSelectionCountState = selector<number>({
  key: 'recipientsList_exportSelectionCountState',
  get: ({ get }) => {
    const { mode, checked } = get(selectionState)
    const { totalItems } = get(paginationState)

    return mode === 'all' || (mode === 'selection' && checked.length === 0)
      ? totalItems
      : checked.length
  },
})
